import React from 'react';
import { Tabs ,Card  } from 'antd';
import TimeTabel from '../../../components/student/Timetabel/TimeTabel'
import FeeDetails from '../../../components/student/FMS/FeeDetails/FeeDetails'

const { TabPane } = Tabs;


function callback(key) {
  console.log(key);
}

const TabsTop = () => (
  <Card>
     <Tabs defaultActiveKey="1" onChange={callback}>
    <TabPane tab="Today Time Tabel" key="1" >
      <TimeTabel />
    </TabPane>
    <TabPane tab="Fee Transactions" key="2">
      <FeeDetails />
    </TabPane>

  </Tabs>
  </Card>
 
);

export default TabsTop